<template>
    <section class="qapair">
        <section class="question" :class="{ expanded: qa.isExpanded }" @click="$emit('toggleMessage', qa.id)">
            <h4>{{ qa.question }}</h4>
            <img src="@/assets/icons/faq-arrow.png" alt="Expand Arrow">
        </section>
        <p class="answer" :class="{ 'show-answer': qa.isExpanded }" v-html="qa.answer"></p>
    </section>
</template>

<script>
export default {
    name: 'QuestionAnswer',
    props: ['qa'],
}
</script>

<style scoped lang="scss">
.qapair {
    padding: 1rem;
    border: 1px solid #C8C8C8;
    border-radius: .25rem;
    margin-bottom: 1rem;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, */

    h4, p {
        padding: 0;
        color: #555;
    }

    .question {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;

        h4 {
            line-height: 30px;
        }

        img {
            margin-left: 0.2rem;
            height: 20px;
            transform: rotate(0deg);
            transition: transform .2s linear;
        }
    }

    .expanded {
        h4 {
            color: #00AEEF;
        }

        img {
            transform: rotate(180deg);
        }

        @keyframes rotation {
            from {
                transform: rotate(0deg);
            }
            to {
                transform: rotate(180deg);
            }
        }
    }

    .answer {
        display: none;
        text-align: justify;
    }

    .show-answer {
        display: block;
    }
}
</style>